import { CacheVisit } from "./cacheVisit.class";
import { CacheConfiguration } from "./cacheConfig.class";
import { MainMenuPageEntity } from "./mainMenuPage.class";
import { Worker } from "../shared";
import { CacheAssignedPatient } from "./cacheAssignedPatient.class";
import { CacheCarePlanItem } from "./cacheCarePlanItem.class";
import { CacheConfigurableListItem } from "./cacheConfigurableListItem.class";
import { CacheLocation } from "./cacheLocation.class";
import { DeviceVersion } from "./deviceVersion.class";
import { MemberInfo } from "./memberInfo.class";
import {CacheTranslation } from "./cacheTranslation.class";

export class CacheData
{
    Visits: CacheVisit[];
    Configs: CacheConfiguration[];
    MainMenuPages: MainMenuPageEntity[];
    Worker: Worker;
    AssignedPatients: CacheAssignedPatient[];
    AdditionalCarePlanItems: CacheCarePlanItem[];
    Errors: string[];
    ConfigurableList : CacheConfigurableListItem[];
    Locations: CacheLocation[];
    DeviceVersion: DeviceVersion;
    MemberInfo : MemberInfo;
    Translations: CacheTranslation[];
    
    constructor(
        cacheVisits: CacheVisit[],
        cacheConfigurations: CacheConfiguration[],
        mainMenu: MainMenuPageEntity[],
        user: Worker,
        errors: string[],
        cacheAssignedPatients: CacheAssignedPatient[],
        additionalCarePlanItems: CacheCarePlanItem[],
        configurableList: CacheConfigurableListItem[],
        locationList: CacheLocation[],
        device: DeviceVersion,
        member: MemberInfo,
        translations: CacheTranslation[]
    )
    {
        this.Visits = cacheVisits;
        this.Configs = cacheConfigurations;
        this.MainMenuPages = mainMenu;
        this.Worker = user;
        this.AssignedPatients = cacheAssignedPatients;
        this.AdditionalCarePlanItems = additionalCarePlanItems;
        this.Errors = errors;
        this.ConfigurableList = configurableList;
        this.Locations = locationList;
        this.DeviceVersion = device;
        this.MemberInfo = member;
        this.Translations = translations;
    }
}